import { RatingIcons } from '@packages/modules/src/RatingIcons/RatingIcons';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { RatingIconsVerifiedFragmentFragmentDoc } from '@packages/gql/generated/shopping/RatingIconsVerifiedFragmentFragmentDoc';
import type { HTMLAttributes } from 'react';
import { RatingInfo } from '../CustomerRatings/RatingInfo';

/* GraphQL */ `
  fragment RatingIconsVerifiedFragment on RatingProduct {
    avgRating
    reviewCount
  }
`;

export type RatingIconsVerifiedProps = HTMLAttributes<HTMLDivElement> & {
  data: FragmentType<typeof RatingIconsVerifiedFragmentFragmentDoc>;
};

/**
 * RatingIconsVerified component shows review-icons,
 * the amount of given ratings and an information-icon
 * */
export const RatingIconsVerified = ({ data, className, ...props }: RatingIconsVerifiedProps) => {
  const { avgRating, reviewCount } = getFragmentData(RatingIconsVerifiedFragmentFragmentDoc, data);

  const onAction = () => {
    document
      .getElementById('customer-ratings')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <div className={`flex flex-row flex-nowrap items-center gap-0.5 ${className}`} {...props}>
      <div className="mt-[-0.3rem]">
        <RatingIcons
          tabIndex={0}
          avgRating={avgRating}
          reviewCount={reviewCount}
          sx={{
            cursor: 'pointer',
            alignSelf: 'flex-start',
          }}
          onClick={() => {
            onAction();
          }}
          // If RatingIcons are focused, they should also scroll down to customer-ratings on enter key press.
          // Therefore, we use onKeyDown.
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onAction();
            }
          }}
        />
      </div>
      <div>
        <RatingInfo />
      </div>
    </div>
  );
};
